"use strict";

import React from "react";

class DesignViewFooter extends React.Component {
  render() {
    const style = {
      display: "flex",
      position: "absolute",
      height: 50,
      bottom: 0,
      width: "100%",
    };

    return (
      <div style={style} data-intercom-target={"design view footer"}>
        {this.props.children}
      </div>
    );
  }
}

export default DesignViewFooter;
